export default __webpack_public_path__ + "static/knowledgebase-ed1d13d50d82449b25abf039a686ec3e.png";